import CardWithBorderHeading, { CardWithBorderHeadingProps } from './CardWithBorderHeading';

export type { CardWithBorderHeadingProps };
export default CardWithBorderHeading;
